import {css, html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import styles from './tool.styles';
import oldToolStyles from '../../ts/css/old-tool.styles';

@customElement('ui-tool')
export class Tool extends LitElement {
  static readonly styles = [styles, oldToolStyles, css`.hide {display: none;}`];

  @property() headerIcon: 'bell' | 'none' = 'none';

  @state() hasFooter = false;

  onFooterSlotChanged() {
    this.hasFooter = true;
  }

  render() {
    return html`
      <div class="tool-header">
        ${this.getHeaderIconTemplate()}
        <slot name="header"></slot>
      </div>
      <div class="tool-content">
        <slot name="content"></slot>
      </div>
      <div class="${this.hasFooter ? 'tool-footer' : 'hide'}">
        <slot name="footer" @slotchange=${this.onFooterSlotChanged}></slot>
      </div>
    `;
  }

  getHeaderIconTemplate() {
    if (this.headerIcon === 'bell') {
      return html`<div class="icon-bell"></div>`;
    } else {
      return null;
    }
  }
}
